import { render, staticRenderFns } from "./DeviceFile.vue?vue&type=template&id=0cc3f9fe&"
import script from "./DeviceFile.vue?vue&type=script&lang=js&"
export * from "./DeviceFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports